<template>
  <div id="app" style="position: relative;"> 
    <div v-if="path !== 'myLover' && path !== 'user_login' && path !== 'register'">
      <v-header :sereenWidth="sereenWidth" class="header"></v-header>
      <div style="position: relative;" id="page" :style="sereenWidth > 800 ? 'width: 800px; margin: auto;' : 'width: 100%;'">
        <v-left v-if="sereenWidth > 1800" style="position: absolute; left: -470px; top: 20px; padding: 50px 20px; border: 1px solid #666666; border-radius: 10px; width: 300px"></v-left>
        <v-right v-if="sereenWidth > 1800" style="position: absolute; right: -470px; top: 20px; padding: 50px 20px; border: 1px solid #666666; border-radius: 10px; width: 300px"></v-right>
        <router-view/>
      </div>
      <v-footer></v-footer>
      <div class="bottom">
        <div class="gotop" v-show="gotop" @click="toTop">Top</div>
      </div>
    </div>
    <div class="my-lover" v-if="path == 'myLover'">
      <router-view/>
    </div>

    <div v-if="path == 'user_login' || path == 'register'">
      <div :style="sereenWidth > 500 ? 'width: 500px; margin: auto;' : 'width: 100%;'">
        <router-view/>
      </div>
      <v-footer></v-footer>
    </div>
  </div>
</template>

<script>
  import vHeader from '@/components/common/header'
  import VFooter from '@/components/common/footer'
  import vLeft from '@/components/common/leftCard'
  import vRight from '@/components/common/rightCard'
  export default {
    name: 'App',
    data () {
      return {
        path: this.$route.path.replace('/', ''),
        gotop: false,
        sereenWidth: document.body.clientWidth
      }
    },

    watch: {
      '$route' (to, from) { //监听路由是否变化
        this.path = to.path.replace('/', '')
      },
    },
  
    mounted () {
      window.addEventListener("scroll", this.handleScroll, true)
      window.onresize = () => {
        if (window.outerWidth - window.innerWidth > 50){
          alert('调试窗口打开，请关闭！')
          window.close(); 
          window.location = "about:blank";
          return false
        }
        return (() => {
          this.sereenWidth = document.body.clientWidth
        })()
      }
      if(window.outerWidth - window.innerWidth > 50) {
        alert('调试窗口打开中，请关闭！')
        window.close(); 
        window.location = "about:blank"; 
      }
      //禁止任何键盘敲击事件（防止F12和shift+ctrl+i调起开发者工具） 
      // window.onkeydown = window.onkeyup = window.onkeypress = function () { 
      //   window.event.returnValue = false;
      //   return false;
      // }
      //如果用户在工具栏调起开发者工具，那么判断浏览器的可视高度和可视宽度是否有改变，如有改变则关闭本页面 
      // var h = window.innerHeight,w=window.innerWidth; 
      // window.onresize = function () { 
      //   // if (h!= window.innerHeight||w!=window.innerWidth){ 
      //   if (window.outerWidth - window.innerWidth > 50){
      //     alert('调试窗口打开，请关闭！')
      //     window.close(); 
      //     window.location = "about:blank"; 
      //   } 
      // }

      //禁用右键
      document.oncontextmenu = function (event) {
        if (window.event) {
          event = window.event;
        }
        try {
          var the = event.srcElement;
          if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA")) {
            return false;
          }
          return true;
        } catch (e) {
          return false;
        }
      }

      //禁用粘贴
      // document.onpaste = function (event) {
      //   if (window.event) {
      //     event = window.event;
      //   }
      //   try {
      //     var the = event.srcElement;
      //     if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA")) {
      //         return false;
      //     }
      //     return true;
      //   } catch (e) {
      //     return false;
      //   }
      // }

      //禁用复制
      document.oncopy = function (event) {
        if (window.event) {
          event = window.event;
        }
        try {
          var the = event.srcElement;
          if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA")) {
            return false;
          }
          return true;
        } catch (e) {
          return false;
        }
      }

      //禁用剪切
      document.oncut = function (event) {
        if (window.event) {
          event = window.event;
        }
        try {
          var the = event.srcElement;
          if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA")) {
            return false;
          }
          return true;
        } catch (e) {
          return false;
        }
      }

      //屏蔽选中
      // document.onselectstart = function (event) {
      //   if (window.event) {
      //     event = window.event;
      //   }
      //   try {
      //     var the = event.srcElement;
      //     if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA")) {
      //       return false;
      //     }
      //     return true;
      //   } catch (e) {
      //     return false;
      //   }
      // }
    },

    methods: {
      handleScroll() {
        let scrolltop = document.documentElement.scrollTop || document.body.scrollTop
        scrolltop > 30 ? (this.gotop = true) : (this.gotop = false)
      },
      toTop() {
        let top = document.documentElement.scrollTop || document.body.scrollTop
        // 实现滚动效果 
        const timeTop = setInterval(() => {
          document.body.scrollTop = document.documentElement.scrollTop = top -= 50
          if (top <= 0) {
            clearInterval(timeTop)
          }
        }, 10)
      }
    },

    components: {
      vHeader,
      VFooter,
      vLeft,
      vRight
    }
  }
</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
  }

  ul, ol {
    list-style:none;
  }

  html, body, #app, .my-lover {
    height: 100%;
  }

  body {
    /* font-size: .14rem; */
    /* margin: .5rem auto 0; */
    color: #787978;
    font-family: Microsoft Yahei;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* max-width: 800px; */
    width: 100%;
    height: 100%;
    /* height: auto; */
    position: relative;
    background: url(./assets/bg.jpg) repeat;
  }

  /* .header {
    background-image: url(./assets/timg5.gif);
  } */

  .bottom .gotop {
    text-align: center;
    position: fixed;
    right: 5%;
    bottom: 30px;
    cursor: pointer;
    padding: 10px;
    border-radius: 50%;
    background: white;
    color: #000000;
    box-shadow: 0px 0px 5px 0px #666666;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: rgb(123, 117, 128);
  }
  
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #ededed;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue